import { createFileRoute } from '@tanstack/react-router';
import { ExpensesPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/expenses/')({
  component: ExpensesRoute,
});

function ExpensesRoute() {
  const { orgId } = Route.useParams();
  return <ExpensesPage orgId={orgId} />;
}
